import { useNavigate } from 'react-router';
import { useGoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import { useEffect } from 'react';

function Login() {
    const navigate = useNavigate();
    const { email, login } = useAuth();

    useEffect(() => {
        if (email) {
            navigate('/');
        }
    }, [email, navigate]);

    const handleLogin = useGoogleLogin({
        scope: "openid email profile https://www.googleapis.com/auth/calendar.events",
        flow: 'auth-code',
        onSuccess: async (codeResponse) => {
            console.log("Authorization Code:", codeResponse.code);
            try {
                const backendResponse = await fetch(`${process.env.REACT_APP_BACKEND_ENDPOINT}/doctor/createDoctor`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include",
                    body: JSON.stringify({ code: codeResponse.code }),
                });

                const backendData = await backendResponse.json();
                console.log("Tokens and user info from backend:", backendData);

                login(backendData.data.createdDoctor.email, backendData.data.createdDoctor.id, backendData.data.createdDoctor.hospital_id, backendData.data.createdDoctor.status, backendData.data.accessToken);
                navigate("/");

            } catch (err) {
                console.error("Backend login failed:", err);
            }
        },
        onError: (error) => console.log("Login Failed:", error),
    });

    return (
        <div className="flex justify-center items-center h-screen bg-gradient-to-br from-green-50 to-blue-50">
            <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md text-center">
                {/* Heading */}
                <h1 className="text-3xl font-bold text-gray-800 mb-2">MyBioTick</h1>
                <p className="text-gray-500 mb-8">Your secure gateway to better health management</p>

                {/* Google Sign-in Button */}
                <button
                    onClick={handleLogin}
                    className="flex items-center justify-center gap-3 w-full px-6 py-3 bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-gray-300"
                >
                    <img
                        src="https://www.svgrepo.com/show/475656/google-color.svg"
                        alt="Google logo"
                        className="w-6 h-6"
                    />
                    <span className="text-gray-700 font-medium">Sign in with Google as Doctor</span>
                </button>

                {/* Footer Text */}
                <p className="mt-2 text-sm text-gray-400">
                    or
                </p>
                <p className="mt-2 text-gray-600">
                    Sign In as  {" "}
                    <a href={process.env.REACT_APP_ADMIN_ENDPOINT} className="text-blue-500 hover:underline">Admin</a>
                </p>
                <p className="mt-6 text-sm text-gray-400">
                    By signing in, you agree to our{" "}
                    <a href="/terms" className="text-blue-500 hover:underline"> Terms</a> and{" "}
                    <a href="/privacy-policy" className="text-blue-500 hover:underline">Privacy Policy</a>.
                </p>
            </div>
        </div>
    );
}

export default Login;